import React from 'react';
import { bancosEmFrase } from '../data/bancosAceitos';
import { AcessoAoBanco } from '../services/api';

/**
 * O Open Finance para quem ainda não tem acesso: a oferta do plano Completo.
 * Quem quer troca de plano em "Meu plano", e paga pelo Asaas (22/10).
 *
 * O pedido, a fila de dez vagas e o QR code do Pix conferido à mão (08/10)
 * saíram em 23/10.
 */
interface Props {
  acesso: AcessoAoBanco;
  onComoFunciona: () => void;
  /** Abre "Meu plano", onde se troca para o Completo. */
  onVerPlano?: () => void;
}

/**
 * O ícone de cada item do que está incluído. Traço fino, na cor do tema,
 * num quadradinho claro. Decorativo: o texto ao lado já diz tudo, então o
 * leitor de tela pula.
 */
const Icone: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <i className="bco-abre-icone" aria-hidden="true">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      {children}
    </svg>
  </i>
);

const reais = (centavos: number): string => `R$ ${(centavos / 100).toFixed(2).replace('.', ',')}`;

const OfertaDoOpenFinance: React.FC<Props> = ({ acesso, onComoFunciona, onVerPlano }) => {
  const preco = reais(acesso.precoCentavos);

  /** O que o plano é. */
  const infos = (
    <>
      <ul className="bco-abre-lista com-icones">
        <li>
          <Icone><path d="M3 12V4h8l10 10-8 8L3 12z" /><circle cx="7.5" cy="8.5" r="1.5" /></Icone>
          <strong>Categoria</strong>
          <span>Descobre sozinho; quando não sabe, pergunta.</span>
        </li>
        <li>
          <Icone><path d="M4 7h10M18 7h2M4 17h2M10 17h10" /><circle cx="16" cy="7" r="2" /><circle cx="8" cy="17" r="2" /></Icone>
          <strong>Você no controle</strong>
          <span>Confira antes ou deixe entrar sozinho.</span>
        </li>
        <li>
          <Icone><path d="M20 11a8 8 0 0 0-14.9-3M4 13a8 8 0 0 0 14.9 3" /><path d="M5 4v4h4M19 20v-4h-4" /></Icone>
          <strong>Atualizado todo dia</strong>
          <span>Às 6h, ou na hora, quando você pedir.</span>
        </li>
        <li>
          <Icone><rect x="3" y="6" width="18" height="12" rx="2" /><circle cx="12" cy="12" r="2.5" /><path d="M6.5 9.5v.01M17.5 14.5v.01" /></Icone>
          <strong>{preco} por mês, no Completo</strong>
          {/* O banco extra mora aqui (22/10): um item a menos para a oferta caber sem rolar. */}
          <span>
            Com 1 banco
            {acesso.precoDoBancoExtraCentavos ? `; cada um a mais, ${reais(acesso.precoDoBancoExtraCentavos)}` : ''}.
            {' '}Pix ou cartão, sem fidelidade.
          </span>
        </li>
      </ul>
      <p className="bco-abre-seguro">Só leitura: daqui não sai Pix nem pagamento.</p>
      {/*
        Quais bancos e como é a autorização: recolhido (22/10, a tela não pode
        rolar). A pergunta "o meu banco está?" continua a um toque, antes de
        pagar.
      */}
      <details className="bco-abre-mais">
        <summary>Quais bancos e como é a autorização</summary>
        <p className="bco-abre-bacen">
          <strong>Bancos:</strong> {bancosEmFrase()}, e mais de 100 instituições do Open Finance.
        </p>
        <p className="bco-abre-bacen">
          O Open Finance é regulado pelo Banco Central. A autorização é dada no site do seu banco, e
          você pode cancelar quando quiser. Só vem o que está no seu nome: cartão adicional de outra
          pessoa fica de fora.
        </p>
      </details>
    </>
  );

  return (
    <div className="bco-vazio">
      <h3 className="bco-abre-titulo">Seu banco conectado, seus gastos em dia</h3>
      <p className="bco-abre-sub">
        {acesso.planoSemBanco
          ? 'O FinTracking lê o extrato e lança por você. Seu plano de agora não inclui banco.'
          : 'O FinTracking lê o extrato todo dia e lança por você.'}
      </p>
      {infos}
      <div className="bco-acoes bco-oferta-acoes">
        {onVerPlano && (
          <button className="bco-btn principal" onClick={onVerPlano}>
            {acesso.planoSemBanco ? 'Trocar para o Completo' : 'Ver o plano Completo'}
          </button>
        )}
        <button className="bco-link" onClick={onComoFunciona}>Como funciona</button>
      </div>
    </div>
  );
};

export default OfertaDoOpenFinance;
